import { render, staticRenderFns } from "./quote-container-block.vue?vue&type=template&id=587b69b4&"
import script from "./quote-container-block.vue?vue&type=script&lang=js&"
export * from "./quote-container-block.vue?vue&type=script&lang=js&"
import style0 from "./quote-container-block.vue?vue&type=style&index=0&id=587b69b4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports